"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var deepmerge_1 = __importDefault(require("deepmerge"));
var ThemeProvider_1 = require("../ThemeProvider");
exports.headlineTheme = function (theme) {
    var componentTheme = {
        1: {
            color: theme.base.color.text,
            fontSize: {
                mobile: '1.688rem',
                tablet: '2.625rem',
            },
            lineHeight: {
                mobile: '2.25rem',
                tablet: '3.625rem',
            },
            fontWeight: '300',
            font: ThemeProvider_1.renderFont('base', 'normal', theme),
        },
        2: {
            color: theme.base.color.text,
            fontSize: {
                mobile: '1.5rem',
                tablet: '1.75rem',
            },
            lineHeight: {
                mobile: '2rem',
                tablet: '2.5rem',
            },
            fontWeight: 'normal',
            font: ThemeProvider_1.renderFont('base', 'normal', theme),
        },
        3: {
            color: theme.base.color.text,
            fontSize: {
                mobile: '1.313rem',
                tablet: '1.625rem',
            },
            lineHeight: {
                mobile: '1.75rem',
                tablet: '2.313rem',
            },
            fontWeight: 'normal',
            font: ThemeProvider_1.renderFont('base', 'normal', theme),
        },
        4: {
            color: theme.base.color.text,
            fontSize: {
                mobile: '1rem',
                tablet: '1.25rem',
            },
            lineHeight: {
                mobile: '1.313rem',
                tablet: '1.75rem',
            },
            fontWeight: 'normal',
            font: ThemeProvider_1.renderFont('base', 'normal', theme),
        },
        5: {
            color: theme.base.color.text,
            fontSize: {
                mobile: '0.938rem',
                tablet: '1rem',
            },
            lineHeight: {
                mobile: '1.25rem',
                tablet: '1.375rem',
            },
            fontWeight: '500',
            font: ThemeProvider_1.renderFont('base', 'normal', theme),
        },
        6: {
            color: theme.base.color.text,
            fontSize: {
                mobile: '0.813rem',
                tablet: '0.75rem',
            },
            lineHeight: {
                mobile: '1.25rem',
                tablet: '2.75rem',
            },
            letterSpacing: '0.5px',
            textTransform: 'uppercase',
            fontWeight: '500',
            font: ThemeProvider_1.renderFont('base', 'bold', theme),
        },
        spacer: {
            size: {
                normal: '8rem',
                short: '3.875rem',
            },
            color: theme.primary.color.normal,
        },
        subheadline: {
            color: theme.greyDark.color.normal,
        },
    };
    if (theme.component.headline) {
        componentTheme = deepmerge_1.default(componentTheme, theme.component.headline);
    }
    return __assign(__assign({}, theme), { component: __assign(__assign({}, theme.component), { headline: componentTheme }) });
};
exports.default = exports.headlineTheme;
//# sourceMappingURL=theme.js.map